"use client";
import { useMemo, useState } from "react";
import { PostListResponse } from "@onair/repositories";
import { Button } from "@mui/material";
import { cn } from "@onair/utils/cn";
import { useGetLearningAndDevelopmentPostsInfiniteQuery } from "@onair/operations";
import CategoryFilter, { CategoryFilterProps } from "./category-filter";
import PostList from "./post-list";
import EmptyData from "@onair/ui/empty-data";
import { LoadingSpinner } from "#src/components";

interface PostListContainerProps {
	className?: string;
	categories: CategoryFilterProps["items"];
	defaultQuery: {
		pageSize: number;
		page: number;
		categories: number[];
	};
}
const PostListContainer: React.FC<PostListContainerProps> = ({
	className,
	defaultQuery,
	categories,
}) => {
	const [queryFilter, setQueryFilter] = useState(defaultQuery);
	const { data, fetchNextPage, isFetchingNextPage, isPending } =
		useGetLearningAndDevelopmentPostsInfiniteQuery(queryFilter);

	const postList = useMemo(() => {
		return (
			data?.pages.reduce<Exclude<PostListResponse["data"], undefined>>(
				(acc, item) => {
					if (item.data) {
						acc = [...acc, ...item.data];
					}
					return acc;
				},
				[],
			) || []
		);
	}, [data]);

	const isShowButtonLoadmore = useMemo(() => {
		const pageCount = data?.pages[0].meta?.pagination?.pageCount || 1;
		const pageParams = (data?.pageParams || [1]) as number[];
		const lastPage = pageParams[pageParams.length - 1];

		return lastPage < pageCount;
	}, [data]);

	const handleSelectCategory: CategoryFilterProps["onSelect"] = (cat) => {
		setQueryFilter((prev) => {
			const { categories } = prev;
			let updateCategories = [...categories];

			const indexCatId = updateCategories.findIndex(
				(catId) => catId === cat.id,
			);
			if (indexCatId === -1) {
				updateCategories = [...updateCategories, cat.id];
			} else {
				updateCategories.splice(indexCatId, 1);
			}
			return {
				...prev,
				page: 1,
				categories: [cat.id],
			};
		});
	};
	const handleFetchNextPost = () => {
		fetchNextPage();
	};
	return (
		<>
			<CategoryFilter
				selectedIds={queryFilter.categories}
				onSelect={handleSelectCategory}
				//@ts-ignore
				items={categories}
			/>
			<div className="h-8"></div>
			<div className={cn("blog-sections relative")}>
				{isPending ? (
					<div className="loading absolute bg-white/60 left-0 top-0 bottom-0 right-0 z-20">
						<LoadingSpinner />
					</div>
				) : null}
				{postList.length ? (
					<>
						<PostList items={postList} />
						{isShowButtonLoadmore ? (
							<div className="flex items-center justify-center py-6">
								<Button
									variant="outlined"
									onClick={handleFetchNextPost}
									disabled={isFetchingNextPage}
								>
									{isFetchingNextPage ? "Loading..." : "Xem thêm"}
								</Button>
							</div>
						) : null}
					</>
				) : (
					<EmptyData />
				)}
			</div>
		</>
	);
};
export default PostListContainer;
